import { memo } from 'react';
import style from './Placeholder.module.css';

export const Placeholder = memo(() => <div className={style.placeholder} />);
